import * as React from "react";
import styled, { css } from "styled-components";
import LogViewHeader from "logview/components/LogViewHeader";
import LogViewCell from "logview/components/LogViewCell";
import LogViewRow from "logview/components/LogViewRow";
import { Skeleton } from "components/common";
import BulkSelectCell from "logview/components/BulkSelectCell";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import { CELL_SEP } from "logview/Constants";
const ROWS_AMOUNT = 5;
const Table = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-anchor: none;
    overflow-y: auto;
    position: relative;
    gap: ${theme.spacings.xxs};
    height: 100%;
  `
);
const TableInner = styled.div`
  /* Remove bottom border of last row of last page */
  > *:last-child > *:last-child {
    border-bottom: 0;
  }
`;
const SkeletonContainer = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacings.xs} 0;
  `
);
const LogViewSkeleton = ({ columns }) => /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(TableInner, null, /* @__PURE__ */ React.createElement(LogViewHeader, { columns, displayBulkSelectCol: true }), Array.from({ length: ROWS_AMOUNT }).map((_, index) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ React.createElement(LogViewRow, { key: `row-skeleton-${index}` }, /* @__PURE__ */ React.createElement(BulkSelectCell, null, /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      onChange: () => {
      },
      title: "Checkbox placeholder",
      checked: false,
      disabled: true,
      "aria-label": "Checkbox placeholder"
    }
  )), columns.toArray().map((fieldName) => /* @__PURE__ */ React.createElement(React.Fragment, { key: `row-skeleton-fragment-${fieldName}` }, /* @__PURE__ */ React.createElement(LogViewCell, { fieldName, key: `row-skeleton-${fieldName}` }, /* @__PURE__ */ React.createElement(SkeletonContainer, null, /* @__PURE__ */ React.createElement(Skeleton, { height: 10, width: "60%" }))), fieldName !== columns.last() ? CELL_SEP : null)))
))));
export default LogViewSkeleton;
